import React, { useContext, useEffect, useState } from "react";
import { useStyles } from "./style";
import { Paper, IconButton, Menu } from "@mui/material";
import { Box } from "@mui/system";
import { Grid, Typography, Button, Divider, TextField, MenuItem } from "@mui/material";
import AppSearchBar from "../../../Components/AppSearchBar";
import svg8 from "../../../Assets/svg8.svg";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BusinessCardContainer from "./BusinessCardContainer";
import BusinessDetailPage from "./BusinessDetail";
import { useNavigate, useLocation } from "react-router-dom";
import routes from "../../../Utils/routes";
import { getBusinesses } from "../../../Utils/apiService";
import { AuthUser } from "../../../interfaces/Contexts";
import { AuthContext } from "../../../Helpers/Contexts/authContext";
import ListBusiness from "../../../Assets/Events/undraw_pitching_y6kw 1.png"
import useSpeechRecognition from '../../../hooks/useSpeechRecognition';
import Images from '../../../Assets/assetHelper';
import FilterIcon from '../../../Assets/filter.svg';

// Define interface for business data
interface BusinessData {
    Id: string;
    Name: string;
    Description?: string;
    Business_Type__c?: string;
    Phone?: string;
    Business_Email__c?: string;
    Hide_Business_Email__c?: boolean;
    Hide_Business_Phone__c?: boolean;
    Website?: string;
    Business_Address__c?: string;
    Location_URL__c?: string;
    Cover_Image_Url__c?: string;
    Logo_URL__c?: string;
    Is_Active__c?: boolean;
    Business_Approval__c?: string;
    RecordTypeId?: string;
    Business_Directories__r?: {
        records: Array<{
            Contact__r: {
                Name?: string;
                Profile_Picture_URL__c?: string;
            }
        }>
    };
    attributes?: {
        type: string;
        url: string;
    };
}

// Define interface for card data
interface CardData {
    id: string;
    businessImage: string;
    logo: string;
    category: string;
    name: string;
    location: string;
    contactName: string;
    contactImage: string;
}

const useMediaQuery = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 600);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};
const BusinessDirectory: React.FC = () => {
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const { state: { user } } = useContext(AuthContext);
    const userData = user as AuthUser;
    const [localSearchInput, setLocalSearchInput] = useState<string>('');
    const [searchInput, setSearchInput] = useState<string>('');
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
    const [notificationOpen, setNotificationOpen] = useState<boolean>(false);
    const [selectedBusinessId, setSelectedBusinessId] = useState<string | null>(null);
    const [view, setView] = useState<'list' | 'detail'>('list');
    const [selectedFilterType, setSelectedFilterType] = useState<string>("");
    const [selectedLocation, setSelectedLocation] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>('');
    const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
    const sortOptions = ['A - Z', 'Z - A'];

    // State for API data
    const [myBusinesses, setMyBusinesses] = useState<BusinessData[]>([]);
    const [allBusinesses, setAllBusinesses] = useState<BusinessData[]>([]);
    const [selectedBusinessData, setSelectedBusinessData] = useState<BusinessData | null>(null);
    const [businessDirectoryTypes, setBusinessDirectoryTypes] = useState<Array<{ Name: string, Id: string }>>([]);
    const [expressedBusinessInterests, setExpressedBusinessInterests] = useState<any[]>([]);
    const isMobile = useMediaQuery();

    const [businessSource, setBusinessSource] = useState<'all' | 'my'>('all');

    // Add state handling from navigation
    useEffect(() => {
        if (location.state) {
            const { selectedBusinessData, selectedBusinessId, view, businessSource } = location.state as any;
            if (selectedBusinessData && selectedBusinessId && view === 'detail') {
                setSelectedBusinessData(selectedBusinessData);
                setSelectedBusinessId(selectedBusinessId);
                setView('detail');
                setBusinessSource(businessSource);
            }
        }
    }, [location.state]);

    const getStatusStyle = (status: string): { bgcolor: string; color: string } => {
        switch (status) {
            case "Approved":
                return { bgcolor: "#D5ECD2", color: "#1F4B2E" };
            case "Pending":
                return { bgcolor: "#FFF4D6", color: "#7A6000" };
            case "Rejected":
                return { bgcolor: "#FCD8D6", color: "#8B2D2B" };
            case "Inactive":
                return { bgcolor: "#E4E4E7", color: "#3F3F46" };
            default:
                return { bgcolor: "#E4E4E7", color: "#3F3F46" };
        }
    };
    const getUrlParameter = (name: string) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    };
    const businessid = getUrlParameter('businessid');
    console.log(businessid, "businessid from url");

    // Function to fetch businesses
    const fetchBusinesses = async () => {
        try {
            const contactId = userData?.applicantId;
            const response = await getBusinesses(contactId);
            if (response && response.data && response.data.data) {
                const { myBusinesses, allBusinesses, businessDirectoryTypes, expressedBusinessInterests } = response.data.data;
                setMyBusinesses(myBusinesses || []);
                setAllBusinesses(allBusinesses || []);
                setBusinessDirectoryTypes(businessDirectoryTypes || []);
                setExpressedBusinessInterests(expressedBusinessInterests || []);
                return allBusinesses || [];
            }

        } catch (error) {
            console.error("Error fetching businesses:", error);
            return [];
        }
    };

    useEffect(() => {
        fetchBusinesses();
    }, []);

    const { startListening, stopListening, isSupported } = useSpeechRecognition({
        onResult: (speechResult: string) => {
            setLocalSearchInput(speechResult);
            setSearchInput(speechResult);
        },
        onStart: () => {
            console.log('Speech recognition started');
            setNotificationOpen(true);
        },
        onEnd: () => {
            console.log('Speech recognition stopped');
            setNotificationOpen(false);
        },
        onError: (event: Event) => {
            console.error('Speech recognition error:', event);
            setNotificationOpen(false);
        },
    });

    const handleMicHold = (): void => {
        if (!isSupported) {
            console.log('Speech recognition not supported');
            return;
        }
        startListening();
    };

    const handleMicRelease = (): void => {
        stopListening();
    };

    const toggleFilter = (): void => {
        setIsFilterOpen(true);
    };

    const closeFilter = (): void => {
        setIsFilterOpen(false);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setLocalSearchInput(event.target.value);
        setSearchInput(event.target.value);
    };

    const clearFilters = (): void => {
        setLocalSearchInput('');
        setSearchInput('');
        setSelectedFilterType("");
        setSelectedLocation("");
        setIsFilterOpen(false);
    };

    const applyFilters = (): void => {
        setIsFilterOpen(false);
    };

    const handleSortButtonClick = (event: React.MouseEvent<HTMLElement>): void => {
        setSortAnchorEl(event.currentTarget);
    };

    const handleSortMenuClose = (): void => {
        setSortAnchorEl(null);
    };

    const handleSortSelect = (option: string): void => {
        setSortBy(option);
        handleSortMenuClose();
    };

    useEffect(() => {
        if (businessid) {
            const business = myBusinesses.find(b => b.Id === businessid);
            if (business) {
                setSelectedBusinessData(business);
                setSelectedBusinessId(businessid);
                setView('detail');
                setBusinessSource('all'); // Assuming businessid is from all businesses
                console.log("Business found with ID:", businessid);
            } else {
                console.error("Business not found with ID:", businessid);
            }
        }
    }, [businessid, allBusinesses]);
    const handleBusinessCardClick = (businessId: string, source: 'all' | 'my' = 'all'): void => {
        setBusinessSource(source);

        // Debug logs to check what's happening
        console.log("Clicked business ID:", businessId);
        console.log("Source:", source);
        console.log("My Businesses:", myBusinesses);
        console.log("All businesses:", allBusinesses);

        const selectedBusiness = source === 'my'
            ? myBusinesses.find(business => business.Id === businessId)
            : allBusinesses.find(business => business.Id === businessId);

        console.log("Selected business:", selectedBusiness);

        if (selectedBusiness) {
            setSelectedBusinessData(selectedBusiness);
            setSelectedBusinessId(businessId);
            setView('detail');

            if (isMobile) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

            navigate(`/business directory`, {
                state: {
                    businessName: selectedBusiness.Name,
                    businessSource: source
                }
            });
        } else {
            console.error("Business not found with ID:", businessId);
        }
    };

    const handleBackToList = (): void => {
        setSelectedBusinessId(null);
        setSelectedBusinessData(null);
        setView('list');
    };

    const distinctTypes = Array.from(
        new Set(allBusinesses.map(business => business.Business_Type__c).filter(Boolean))
    ) as string[];

    const filteredBusinesses = allBusinesses.filter(business => {
        const matchesSearch = searchInput.trim() === "" ||
            business.Name.toLowerCase().includes(searchInput.trim().toLowerCase());

        const matchesType = selectedFilterType === "" ||
            business.Business_Type__c === selectedFilterType;

        const matchesLocation = selectedLocation === "" ||
            (business.Business_Address__c &&
                business.Business_Address__c.toLowerCase().includes(selectedLocation.toLowerCase()));

        return matchesSearch && matchesType && matchesLocation;
    });

    let sortedBusinesses = [...filteredBusinesses];
    if (sortBy === 'A - Z') {
        sortedBusinesses.sort((a, b) => (a?.Name || '').localeCompare(b?.Name || '', undefined, { sensitivity: 'base' }));
    } else if (sortBy === 'Z - A') {
        sortedBusinesses.sort((a, b) => (b?.Name || '').localeCompare(a?.Name || '', undefined, { sensitivity: 'base' }));
    } else if (sortBy === 'Recently joined') {
        sortedBusinesses.sort((a: any, b: any) => new Date(b?.CreatedDate || 0).getTime() - new Date(a?.CreatedDate || 0).getTime());
    }

    const transformedBusinessCards: CardData[] = sortedBusinesses.map(business => {
        const defaultContact = {
            name: "Unknown Contact",
            image: Images.Images.NoDataTheme
        };

        let contactInfo = defaultContact;
        if (business.Business_Directories__r && business.Business_Directories__r.records.length > 0) {
            const firstContact = business.Business_Directories__r.records[0].Contact__r;
            contactInfo = {
                name: firstContact.Name || defaultContact.name,
                image: firstContact.Profile_Picture_URL__c || defaultContact.image
            };
        }

        return {
            id: business.Id,
            businessImage: business.Cover_Image_Url__c || Images.Images.NoDataTheme,
            logo: business.Logo_URL__c || Images.Images.NoDataTheme,
            category: business.Business_Type__c || "No Category",
            name: business.Name,
            location: business.Business_Address__c || "No Location",
            contactName: contactInfo.name,
            contactImage: contactInfo.image
        };
    });

    const refreshSelectedBusinessData = async () => {
        await fetchBusinesses();
    };

    return (
        <Grid container spacing={2} >
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Paper style={{ boxShadow: 'none', height: isMobile ? "100%" : 'calc(100vh - 143px)' }} className={`${classes.cardContainer1}`}>
                    {view === 'list' ? (
                        <>
                            {isMobile ? (
                                <Grid container spacing={2} sx={{ marginBottom: 1 }}>
                                    <Grid item xs={12}>
                                        <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
                                            <Grid item>
                                                <Typography
                                                    sx={{
                                                        fontSize: '16px',
                                                        color: '#373A45',
                                                        fontWeight: '500',
                                                        textAlign: 'start',
                                                        '@media (max-width: 600px)': {
                                                            fontSize: '14px !important',
                                                        },
                                                    }}
                                                >
                                                    {'All Businesses'}
                                                </Typography>
                                            </Grid>
                                            <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Button
                                                    onClick={() => navigate(routes.createbusinessdirectory)}
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                >
                                                    List your Business
                                                </Button>
                                                {filteredBusinesses.length > 2 && (
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={() => navigate(routes.allBusinesses, {
                                                            state: {
                                                                businesses: allBusinesses,
                                                                title: "All Businesses",
                                                                searchInput: searchInput,
                                                                selectedFilterType: selectedFilterType,
                                                                selectedLocation: selectedLocation
                                                            }
                                                        })}
                                                    >
                                                        View more
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppSearchBar
                                            handleMicHold={handleMicHold}
                                            handleMicRelease={handleMicRelease}
                                            localSearchInput={localSearchInput}
                                            handleChange={handleChange}
                                            openSnackbar={notificationOpen}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="flex-end" gap={1} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
                                            <Button
                                                style={{
                                                    color: "#373A45",
                                                    backgroundColor: "#E8EBF3",
                                                    borderRadius: 5,
                                                    padding: "7px 13px"
                                                }}
                                                endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                                                onClick={handleSortButtonClick}
                                            >
                                                <Typography sx={{ fontWeight: 500, fontSize: '12px' }}>{sortBy ? sortBy : 'Sort by'}</Typography>
                                            </Button>
                                            <Menu
                                                anchorEl={sortAnchorEl}
                                                open={Boolean(sortAnchorEl)}
                                                onClose={handleSortMenuClose}
                                                PaperProps={{
                                                    sx: {
                                                        borderRadius: 2,
                                                        minWidth: 180,
                                                        boxShadow: 3,
                                                        mt: 1,
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            >
                                                <MenuItem onClick={() => handleSortSelect('')} selected={sortBy === ''} sx={{ fontWeight: sortBy === '' ? 600 : 400 }}>
                                                    Clear
                                                </MenuItem>
                                                {sortOptions.map((option) => (
                                                    <MenuItem key={option} onClick={() => handleSortSelect(option)} selected={sortBy === option} sx={{ fontWeight: sortBy === option ? 600 : 400 }}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </Box>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ marginBottom: 1 }}
                                >
                                    <Grid item>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                color: '#373A45',
                                                fontWeight: '500',
                                                textAlign: 'start',
                                                '@media (max-width: 600px)': {
                                                    fontSize: '14px !important',
                                                },
                                            }}
                                        >
                                            {'All Businesses'}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Box display="flex" alignItems="center" gap={1} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
                                            <AppSearchBar
                                                handleMicHold={handleMicHold}
                                                handleMicRelease={handleMicRelease}
                                                localSearchInput={localSearchInput}
                                                handleChange={handleChange}
                                                openSnackbar={notificationOpen}
                                            />
                                            <Button
                                                variant="contained"
                                                color="info"
                                                size="large"
                                                endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                                                onClick={handleSortButtonClick}
                                            >
                                                <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>{sortBy ? sortBy : 'Sort by'}</Typography>
                                            </Button>
                                            <Menu
                                                anchorEl={sortAnchorEl}
                                                open={Boolean(sortAnchorEl)}
                                                onClose={handleSortMenuClose}
                                                PaperProps={{
                                                    sx: {
                                                        borderRadius: 2,
                                                        // minWidth: 180,
                                                        boxShadow: 3,
                                                        mt: 1,
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            >
                                                {/* <MenuItem onClick={() => handleSortSelect('')} selected={sortBy === ''} sx={{ fontWeight: sortBy === '' ? 600 : 400 }}>
                                                    Clear
                                                </MenuItem> */}
                                                {sortOptions.map((option) => (
                                                    <MenuItem key={option} onClick={() => handleSortSelect(option)} selected={sortBy === option} sx={{ fontWeight: sortBy === option ? 600 : 400 }}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                            {/* Filter Modal */}
                            {isFilterOpen && (
                                <Grid
                                    style={{
                                        zIndex: "999",
                                        position: "relative",
                                        width: "100%"
                                    }}
                                >
                                    <Paper
                                        className={`filter-modal ${classes.cardContainer2} ${isMobile ? classes.filterModalMobile : ''}`}
                                        style={
                                            isMobile
                                                ? {
                                                    position: "absolute",
                                                    right: "0",
                                                    top: "100%",
                                                    backgroundColor: "white",
                                                    padding: "0px",
                                                    width: "100%",
                                                    zIndex: "999",
                                                    border: "1px solid #E4E4E7",
                                                    borderRadius: "12px",
                                                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                                                    overflowY: "scroll",
                                                    marginTop: "10px",
                                                    transform: "none",
                                                    transition: "none"
                                                }
                                                : {
                                                    position: "absolute",
                                                    right: "0",
                                                    backgroundColor: "white",
                                                    padding: "0px",
                                                    width: "360px",
                                                    zIndex: "999",
                                                    border: "1px solid #E4E4E7",
                                                    borderRadius: "12px",
                                                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                                                    overflowY: "scroll",
                                                }
                                        }
                                    >
                                        <Box p={3} pb={2}>
                                            <Grid container>
                                                <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
                                                    <Typography variant="h6" style={{ fontWeight: "600", fontSize: "18px" }}>
                                                        Filters
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <IconButton onClick={closeFilter} size="small">
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        <Box px={3} pb={3}>
                                            <Box mb={2}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    placeholder="Location"
                                                    value={selectedLocation}
                                                    onChange={(e) => setSelectedLocation(e.target.value)}
                                                    variant="outlined"
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        renderValue: (selected) => {
                                                            return selected ? String(selected) : "Location";
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            height: "36px",
                                                            border: "0.5px solid #B2B3B7",
                                                            borderRadius: "8px"
                                                        }
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                border: '0.5px solid #B2B3B7',
                                                                borderRadius: '8px',
                                                            },
                                                            '&:hover fieldset': {
                                                                border: '0.5px solid #B2B3B7',
                                                            },
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            height: '36px',
                                                            paddingTop: '0',
                                                            paddingBottom: '0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>All Locations</em>
                                                    </MenuItem>
                                                    {Array.from(new Set(allBusinesses
                                                        .map(business => business.Business_Address__c)
                                                        .filter(Boolean)))
                                                        .map((location) => (
                                                            <MenuItem key={location} value={location}>
                                                                {location}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </TextField>
                                            </Box>

                                            <Box mb={2}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    placeholder="Business type"
                                                    value={selectedFilterType}
                                                    onChange={(e) => setSelectedFilterType(e.target.value)}
                                                    variant="outlined"
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        renderValue: (selected) => {
                                                            return selected ? String(selected) : "Business type";
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            height: "36px",
                                                            border: "0.5px solid #B2B3B7",
                                                            borderRadius: "8px"
                                                        }
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                border: '0.5px solid #B2B3B7',
                                                                borderRadius: '8px',
                                                            },
                                                            '&:hover fieldset': {
                                                                border: '0.5px solid #B2B3B7',
                                                            },
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            height: '36px',
                                                            paddingTop: '0',
                                                            paddingBottom: '0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>All Business Types</em>
                                                    </MenuItem>
                                                    {distinctTypes.map((type) => (
                                                        <MenuItem key={type} value={type}>
                                                            {type}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Box>

                                            <Box
                                                mt={8}
                                                display="flex"
                                                justifyContent="space-between"
                                                style={{
                                                    position: "absolute",
                                                    bottom: "20px",
                                                    left: "0",
                                                    right: "0",
                                                    padding: "0 24px"
                                                }}
                                            >
                                                <Button
                                                    onClick={clearFilters}
                                                    style={{
                                                        borderRadius: "8px",
                                                        color: "#111827",
                                                        backgroundColor: "white",
                                                        padding: "8px 16px",
                                                        width: "45%",
                                                        textTransform: "none",
                                                        fontWeight: "500"
                                                    }}
                                                >
                                                    Reset all filters
                                                </Button>
                                                <Button
                                                    onClick={applyFilters}
                                                    style={{
                                                        background: "linear-gradient(90deg, #FAB400 -30.21%, #FFE090 100%)", borderRadius: "8px",
                                                        color: "#5b4200",
                                                        padding: "8px 16px",
                                                        width: "45%",
                                                        textTransform: "none",
                                                        fontWeight: "500"
                                                    }}
                                                >
                                                    Show results
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Grid>
                            )}
                            <Grid
                                className={`scrollbar-cusgray ${classes.cardContainer}`}
                                sx={{
                                    height: { xs: 'auto', md: 'calc(100vh - 120px)' },
                                    overflowY: { xs: 'visible', md: 'scroll' },
                                    scrollbarWidth: { md: 'none' },
                                }}
                            >
                                <BusinessCardContainer
                                    cardData={isMobile ? transformedBusinessCards.slice(0, 2) : transformedBusinessCards}
                                    onCardClick={handleBusinessCardClick}
                                />
                            </Grid>
                        </>
                    ) : (
                        <Grid className={`scrollbar-cusgray ${classes.cardContainer}`}>
                            <BusinessDetailPage
                                businessData={selectedBusinessData as any}
                                businessDirectoryTypes={businessDirectoryTypes}
                                expressedBusinessInterests={expressedBusinessInterests}
                                onBackClick={handleBackToList}
                                businessSource={businessSource}
                                onBusinessDeleted={fetchBusinesses}
                                isMobile={window.innerWidth <= 600}
                                onPromotionSubmitted={refreshSelectedBusinessData}
                            />
                        </Grid>
                    )}
                </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "9px",
                        padding: "15px",
                        textAlign: "start",
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        height: "44vh",
                        overflowY: "scroll",
                        scrollbarWidth: "none"
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography fontWeight={"500"} color={"#373A45"}>My Businesses</Typography>
                        {isMobile && myBusinesses.length > 0 && (
                            <Button
                                onClick={() => navigate(routes.myBusinesses, {
                                    state: {
                                        businesses: myBusinesses,
                                        title: "My Businesses"
                                    }
                                })}
                                variant="contained"
                                color="secondary"
                                size="small"
                               
                            >
                                View more
                            </Button>
                        )}
                    </Box>
                    <hr style={{ opacity: "0.10", color: "black" }} />
                    <Box
                        className="scrollbar-cusgray"
                        sx={{
                            overflowY: 'auto',
                            paddingRight: '5px',
                            flexGrow: 1,
                        }}
                    >
                        <Grid container direction="column" spacing={2}>
                            {myBusinesses.length > 0 ? (
                                (isMobile ? myBusinesses.slice(0, 2) : myBusinesses).map((item, index) => (
                                    <Grid key={index} item onClick={() => {
                                        handleBusinessCardClick(item.Id, 'my');

                                        if (isMobile) {
                                            setTimeout(() => {
                                                window.scrollTo({
                                                    top: 0,
                                                    behavior: 'smooth'
                                                });
                                            }, 100);
                                        }
                                    }} style={{ cursor: 'pointer' }}>
                                        <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, backgroundColor: '#F8F9FC' }}>
                                            <Grid container justifyContent="space-between" alignItems={"center"} columnSpacing={3}>
                                                <Grid item xs={3} >
                                                    <Box
                                                        component="img"
                                                        src={item.Logo_URL__c || Images.Images.NoDataTheme}
                                                        alt="logo"
                                                        alignItems={"center"}
                                                        sx={{
                                                            width: 68,
                                                            height: 68,
                                                            objectFit: 'fill',
                                                            borderRadius: '50%',
                                                            bgcolor: '#fff'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography fontSize={"14px"} fontWeight={500}>
                                                        {item.Name}
                                                    </Typography>
                                                    <Typography fontSize={"12px"} color="text.secondary" mt={0.5}>
                                                        <LocationOnOutlinedIcon style={{ fontSize: "18px" }} /> {item.Business_Address__c || "No Location"}
                                                    </Typography>
                                                    <Button
                                                        size="small"
                                                        sx={{ mt: 1, borderRadius: '20px', fontSize: "10px", textTransform: 'none', color: "#373A45", border: "1px solid #D9DBE1" }}
                                                    >
                                                        {item.Business_Type__c || "No Category"}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={4} textAlign="right" alignSelf="flex-start">
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            ...getStatusStyle(item.Business_Approval__c || ""),
                                                            px: 1.5,
                                                            py: 0.5,
                                                            borderRadius: '20px',
                                                            fontSize: '0.8rem',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {item.Business_Approval__c || "Pending"}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))
                            ) : (
                                <Typography textAlign="center" color="text.secondary" mt={2}>
                                    No businesses found
                                </Typography>
                            )}
                        </Grid>
                    </Box>
                </Grid>

                <Grid
                    className={classes.ShowcaseYourBusiness}
                    sx={{
                        cursor: "pointer",
                        padding: 2,
                        textAlign: "center",
                        borderRadius: 2,
                        backgroundColor: "#EAEFFF",
                        display: { xs: "none", sm: "flex" },
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: { xs: 200, sm: 300 },
                    }}
                    onClick={() => {
                        navigate(routes.createbusinessdirectory, {
                            state: { breadCrumbs: "List your business" },
                        });
                    }}
                ><div className={classes.requestFlex}>
                        <Typography className={classes.RCtypo} sx={{ m: isMobile ? 1 : 1 }}>
                            List Your Business
                        </Typography>
                        {!isMobile && (
                            <ArrowForwardIcon sx={{ fontSize: '15px', color: '#5B4200' }} />
                        )}
                    </div>
                    <Box height={"90%"} display={"flex"} justifyContent={"center"} alignItems={"center"} marginBottom={4}>
                        <img src={ListBusiness} alt="Request Image" style={{ width: '60%', height: 'auto' }} />
                    </Box>

                </Grid>
            </Grid>
        </Grid>
    );
}

export default BusinessDirectory;
